import React from 'react';
import { Link, useLocation } from 'react-router-dom';
export function DriverAdminTabs() {
  const location = useLocation();
  const tabs = [{
    name: 'Conductores',
    path: '/admin/drivers',
    match: '/admin/drivers'
  }, {
    name: 'Vehículos',
    path: '/admin/vehicles',
    match: '/admin/vehicles'
  }, {
    name: 'Asignaciones',
    path: '/admin/assignments',
    match: '/admin/assignments'
  }];
  return <div className="flex items-center gap-2 border-b border-white/10 mb-6 pb-4 overflow-x-auto" data-id="element-548">
      {tabs.map(tab => {
      // Exact match for drivers to avoid matching /admin/drivers with /admin/drivers-something-else if it existed,
      // but startsWith is fine here since routes are distinct.
      const isActive = location.pathname.startsWith(tab.match) && !(tab.match === '/admin/drivers' && location.pathname.startsWith('/admin/drivers/new') === false && location.pathname !== '/admin/drivers');
      return <Link key={tab.path} to={tab.path} className={`px-4 py-2 rounded-xl text-sm font-bold whitespace-nowrap transition-colors ${isActive ? 'bg-[#006847] text-white' : 'text-white/40 hover:text-white hover:bg-white/5'}`} data-id="element-549">
            {tab.name}
          </Link>;
    })}
    </div>;
}